import { useEffect } from 'react';
import { useParams } from 'react-router-dom';
import { useCopilot } from './CopilotContext';

/**
 * Mounted on the study-detail page; tells the copilot which study is open so
 * user messages carry study context and study-scoped effects apply.
 */
export function CopilotStudySync() {
  const { studyUuid } = useParams<{ studyUuid: string }>();
  const { setActiveStudyUuid } = useCopilot();

  useEffect(() => {
    setActiveStudyUuid(studyUuid ?? null);
    return () => setActiveStudyUuid(null);
  }, [studyUuid, setActiveStudyUuid]);

  return null;
}
